/* eslint-disable no-template-curly-in-string */

import { envToBoolean } from './parser';
// Vault stores the Okta config object as a string so we need to explicitly construct the object and Boolean values
const oktaConfig = JSON.parse('${{ UI_OKTA_CONFIG_ANGULAR }}');
const production = JSON.parse('${{ UI_PRODUCTION }}');
const baseUrl = new URL(oktaConfig.redirectUri);

baseUrl.hostname = window.location.hostname;
oktaConfig.redirectUri = baseUrl.href;
oktaConfig.postLogoutUri = `https://${window.location.hostname}`;
const environment = {
    appVersion: '${{ UI_APP_VERSION }}',
    apiBaseUrl: '${{ UI_API_BASE_URL }}',
    production: true,
    hmr: false,
    NODE_ENV: '${{ UI_NODE_ENV }}',
    // MercerOS app default backend api
    // API: '$(API)',
    // MFA/MSSO dev defaults start
    mfaDisabled: envToBoolean('${{ UI_AUTHENTICATION_MFA_ENABLED }}', false),
    mssoDisabled: false,
    mssoFederatedOnly: false,
    // set to true for dev mode
    authDevMode: envToBoolean('${{ UI_DEV_MODE_ENABLED }}', false),
    // Refresh Token Defaults
    jwtTokenExpiresIn: 2 * 60,
    refreshTokenExpiresIn: 60 * 60, // 60 minutes expire session
    // Session Timeout Defaults
    sessionTimeoutDisabled: false,
    sessionTimeoutWarningTime: 2 * 60,
    authUserProfileReturnRoute: '/',
    displayName: '${{ UI_DISPLAY_NAME }}',
    rpid: '${{ UI_RPID }}',
    mssoLoginPost: '${{ UI_MSSO_LOGIN_POST }}',
    mssoFailureUrl: '${{ UI_MSSO_FAILURE_URL }}',
    appName: '${{UI_APP_NAME}}',
    loginSuccessRoute: '/aida',
    mssoSupportEmail: '',
    mfaSupportEmail: '',
    mssoEmailFormEnabled: envToBoolean('${{UI_MSSO_EMAIL_FORM_ENABLED}}', true),
    emeaReg: '${{ UI_EMEA_REG }}',
    startingMfaLocale: 'en-US',
    // MFA/MSSO dev defaults end
    CAAS_API: 'http://localhost:3036/caas/resources/',
    externalAuthIssuer: '${{ UI_EXTERNAL_AUTH_ISSUER }}',
    // externalAuthInvalidTokenUrl: '${{ UI_EXTERNAL_AUTH_INVALID_TOKEN_URL }}',
    // externalAuthExpiredTokenUrl: '${{ UI_EXTERNAL_AUTH_EXPIRED_TOKEN_URL }}',
    enableTaapIntegration: envToBoolean('${{ UI_ENABLE_TAAP_INTEGRATION }}', false),
    oktaEnabled: envToBoolean('${{ UI_OKTA_ENABLED }}', false),
    oktaSamlLogoutUrl: '',
    scopes: 'Calendars.Read Calendars.ReadWrite OnlineMeetings.ReadWrite GroupMember.Read.All offline_access openid profile User.Read User.ReadWrite.All User.ReadWrite',
    clientId: '10a29e30-04b1-40b0-8ddd-c76cac93dded',
    oktaConfig,

    PENDO_ENABLE: true, // envToBoolean('$(PENDO_ENABLE)', false),
    // PENDO_APP_KEY: '$(PENDO_APP_KEY)',
    // PENDO_APP_KEY_AIDA: '$(PENDO_APP_KEY_AIDA)',
    PENDO_APP_KEY_AIDA: 'bd214209-8d38-48b1-7f28-1d1e71ccb285',
    PENDO_TRAINING_GUIDE_ID: '0BKXJJidxG9tmj4wMOl6On3q8NI',
    PENDO_AGENT_ID: 'xnia69GZtMI9K1SPiPTS3f50mZs',
    MODEL_USED: 'mmc-tech-gpt-41-1m-2025-04-14',
    STREAMING_RESPONSE_MESSAGES: '${{ UI_STREAMING_RESPONSE_MESSAGES }}',
    ADMIN_DASHBOARD_USERS: '${{ UI_ADMIN_DASHBOARD_USERS }}'
        .split(',')
        .map((u: string) => u.trim()),
    maxFilesPerUser: 20,
    enableDirectLogin: envToBoolean('${{ UI_ENABLE_DIRECT_LOGIN }}', false),
};

export default environment;
